goog.provide("shadow.js.shim.module$$mui$material$Typography$default");
shadow.js.shim.module$$mui$material$Typography$default = shadow.js.shim.module$$mui$material$Typography.default;
